"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseProcessSequenceFlows = void 0;
const index_1 = require("../../Model/index");
const TypeFactory_1 = require("../TypeFactory");
function parseProcessSequenceFlows(data) {
    const sequenceFlowsRaw = (0, TypeFactory_1.getModelPropertyAsArray)(data, index_1.BpmnTags.CommonElement.SequenceFlow);
    if (!sequenceFlowsRaw) {
        return [];
    }
    const sequenceFlows = [];
    for (const sequenceFlowRaw of sequenceFlowsRaw) {
        const sequenceFlow = (0, TypeFactory_1.createObjectWithCommonProperties)(sequenceFlowRaw, index_1.Model.ProcessElements.SequenceFlow);
        sequenceFlow.name = sequenceFlowRaw.name;
        sequenceFlow.sourceRef = sequenceFlowRaw.sourceRef;
        sequenceFlow.targetRef = sequenceFlowRaw.targetRef;
        if (sequenceFlowRaw[index_1.BpmnTags.FlowElementProperty.ConditionExpression]) {
            const conditionData = sequenceFlowRaw[index_1.BpmnTags.FlowElementProperty.ConditionExpression];
            sequenceFlow.conditionExpression = {
                type: conditionData[index_1.BpmnTags.FlowElementProperty.XsiType],
                expression: conditionData._,
            };
        }
        sequenceFlows.push(sequenceFlow);
    }
    return sequenceFlows;
}
exports.parseProcessSequenceFlows = parseProcessSequenceFlows;
//# sourceMappingURL=SequenceFlowParser.js.map